/* eslint-disable react/jsx-props-no-spreading */
import { type FC } from 'react';
import type { ListingPaginationProps } from '../ListingPagination/ListingPagination';
import CardContainer, { type CardContainerProps } from '3-components/CardContainer/CardContainer';
import ListingAppPagination from '3-components/ListingApp/ListingPagination/ListingPagination';
import { ListingLoader, ListingNoItem } from '../ListingUI/ListingUI';


export interface ListingContentProps extends Pick<CardContainerProps, 'cols' | 'singleColumnOnTablet'> {
    loadingLabel?: string;
    noItemsLabel: string;
    isFetching?: boolean;
    isNoItems?: boolean;
    pagination?: ListingPaginationProps;
    children?: React.ReactNode;
}

const ListingContent: FC<ListingContentProps> = ({
    isFetching,
    isNoItems,
    loadingLabel,
    noItemsLabel,
    cols,
    singleColumnOnTablet,
    pagination,
    children,
}) => {
    if (isFetching) {
        return (
            <ListingLoader loadingMessage={loadingLabel} />
        );
    }

    if (isNoItems) {
        return (
            <ListingNoItem noItemMessage={noItemsLabel} />
        );
    }

    return (
        <div className="listing-content">
            <CardContainer cols={cols} singleColumnOnTablet={singleColumnOnTablet} className="listing-app-cards-container">
                {children}
            </CardContainer>
            {pagination && pagination.itemsPerPage < pagination.totalItems && (
                <ListingAppPagination {...pagination} />
            )}
        </div>
    );
};

export default ListingContent;
